import "./index.scss";
import { ReactComponent as FeedbackInfoIcon } from "assets/feedback-info-icon.svg";
import { ReactComponent as FeedbackWarningIcon } from "assets/feedback-warning-icon.svg";

export const PaymentFeedback = ({ variant = "info", message }) => (
  <section className={`payment-feedback ${variant}`}>
    {variant === "warning" ? (
      <FeedbackWarningIcon alt="warning icon" />
    ) : (
      <FeedbackInfoIcon alt="info icon" />
    )}
    <p>{message}</p>
  </section>
);
